export const resourceTypes = (t) => {
  return [
    {
      workingEnvironment: "On-Prem Cluster",
      resourceClass: "ON_PREM",
      resourceType: "ON_PREM",
      isDiscovered: "Yes",
      cloudProvider: "ONPREM",
      label: t("on_prem_ontap_cluster"),
    },
    {
      workingEnvironment: "On-Prem Cluster",
      resourceClass: "onpremClusterDirect",
      resourceType: "onpremClusterDirect",
      isDiscovered: "Yes",
      cloudProvider: "ONPREM",
      label: t("on_prem_ontap_cluster"),
    },
    {
      workingEnvironment: "ESeries",
      resourceClass: "STORAGE_SERVICES",
      resourceType: "ESERIES",
      isDiscovered: "Yes",
      cloudProvider: "ESERIES",
      label: t("e_series"),
    },
    {
      workingEnvironment: "StorageGrid",
      resourceClass: "STORAGE_SERVICES",
      resourceType: "SG",
      isDiscovered: "Yes",
      cloudProvider: "StorageGRID",
      label: t("storage_grid"),
    },
    {
      workingEnvironment: "CVO",
      resourceClass: "VSA",
      resourceType: "AWS",
      isDiscovered: "Yes",
      cloudProvider: "AWS",
      label: t("cloud_volumes_ontap"),
    },
    {
      workingEnvironment: "CVO",
      resourceClass: "VSA",
      resourceType: "AZURE",
      isDiscovered: "Yes",
      cloudProvider: "AZURE",
      label: t("cloud_volumes_ontap"),
    },
    {
      workingEnvironment: "CVO",
      resourceClass: "VSA",
      resourceType: "GCP",
      isDiscovered: "Yes",
      cloudProvider: "GCP",
      label: t("cloud_volumes_ontap"),
    },
    {
      workingEnvironment: "CVO HA",
      resourceClass: "VSA",
      resourceType: "AWSHA",
      isDiscovered: "Yes",
      cloudProvider: "AWS",
      label: t("cvo_ha"),
    },
    {
      workingEnvironment: "CVO HA",
      resourceClass: "VSA",
      resourceType: "AZUREHA",
      isDiscovered: "Yes",
      cloudProvider: "AZURE",
      label: t("cvo_ha"),
    },
    {
      workingEnvironment: "CVO HA",
      resourceClass: "VSA",
      resourceType: "GCPHA",
      isDiscovered: "Yes",
      cloudProvider: "GCP",
      label: t("cvo_ha"),
    },
    {
      workingEnvironment: "CVS",
      resourceClass: "CVS",
      resourceType: "CLOUD-VOLUMES",
      isDiscovered: "Yes",
      cloudProvider: "GCP",
      label: t("cloud_volumes_service"),
    },
    {
      workingEnvironment: "ANF",
      resourceClass: "ANF",
      resourceType: "CLOUD-VOLUMES",
      isDiscovered: "Yes",
      cloudProvider: "AZURE",
      label: t("netapp_files"),
    },
    {
      workingEnvironment: "OCI NetApp Storage Service",
      resourceClass: "ocisn",
      resourceType: "cluster",
      isDiscovered: "Yes",
      cloudProvider: "OCI",
      label: t("oracle_cloud"),
    },
    {
      workingEnvironment: "Kubernates Cluster",
      resourceClass: "K8S_CLUSTER",
      resourceType: "K8S_CLUSTER",
      isDiscovered: "Yes",
      // TODO: This 'cloudProvider' needs to be confirmed
      cloudProvider: "Unknown",
      label: t("kubernets_cluster"),
    },
    {
      workingEnvironment: "VMware vCenter",
      resourceClass: "STORAGE_SERVICES",
      resourceType: "VMWARE_VCENTER",
      isDiscovered: "Yes",
      cloudProvider: "ONPREM",
      label: t("vcenter"),
    },
    {
      workingEnvironment: "SQL Server",
      resourceClass: "STORAGE_SERVICES",
      resourceType: "MSSQL",
      isDiscovered: "Yes",
      cloudProvider: "AWS",
      label: t("sql_server"),
    },
    {
      workingEnvironment: "Postgress Server",
      resourceClass: "STORAGE_SERVICES",
      resourceType: "POSTGRESQL",
      isDiscovered: "Yes",
      cloudProvider: "AWS",
      label: t("PostgreSQL"),
    },
    {
      workingEnvironment: "Microsoft SQL Server Host",
      resourceClass: "backup",
      resourceType: "BR_MSSQL_HOST",
      isDiscovered: "Yes",
      label: t("microsoft_sql_server_host"),
    },
    {
      workingEnvironment: "Oracle Database Host",
      resourceClass: "backup",
      resourceType: "BR_ORACLE_HOST",
      isDiscovered: "Yes",
      label: t("oracle_database_host"),
    },
    {
      workingEnvironment: "VMware vCenter",
      resourceClass: "backup",
      resourceType: "BR_VMWARE_VCENTER",
      isDiscovered: "Yes",
      label: t("vmware_vcenter"),
    },
    {
      workingEnvironment: "Microsoft Hyper-V Host",
      resourceClass: "backup",
      resourceType: "BR_HYPERV_HOST",
      isDiscovered: "Yes",
      label: t("microsoft_hyper_v_host"),
    },
    {
      workingEnvironment: "KVM Host",
      resourceClass: "backup",
      resourceType: "BR_KVM_HOST",
      isDiscovered: "Yes",
      label: t("kvm_host"),
    },
    {
      workingEnvironment: "On-premises ONTAP Storage VM",
      resourceClass: "backup",
      resourceType: "BR_VOLUMES_SVM",
      isDiscovered: "Yes",
      label: t("on_premises_ontap_svm"),
    },
    {
      workingEnvironment: "Kubernetes Cluster",
      resourceClass: "backup",
      resourceType: "BR_K8S_CLUSTER",
      isDiscovered: "Yes",
      label: t("kubernetes_cluster"),
    },
    {
      workingEnvironment: "Kubernetes Namespace",
      resourceClass: "backup",
      resourceType: "BR_K8S_NAMESPACE",
      isDiscovered: "Yes",
      label: t("kubernetes_namespace"),
    },
    {
      workingEnvironment: "AIQ Resources",
      resourceClass: "inventory",
      resourceType: "cluster",
      isDiscovered: "No",
      // TODO: This 'cloudProvider' and 'label' needs to be confirmed
      cloudProvider: "Unknown",      
      label: t("unknown"),
    },
  ];
};

